import { render, staticRenderFns } from "./TrialBalance.vue?vue&type=template&id=dd5170b0"
import script from "./TrialBalance.vue?vue&type=script&lang=js"
export * from "./TrialBalance.vue?vue&type=script&lang=js"
import style0 from "./TrialBalance.vue?vue&type=style&index=0&id=dd5170b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports